<template>
  <div>
    <heads :more="showMore" :msg="title_msg" :states="1"></heads>
    <div class="form_box">
        <div class="form_item">
          <div class="form_title">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</div>
          <div class="form_content input_noborder"><input v-model="real_name" class="ipt_w" type="text" clearable placeholder="请输入姓名"></div>
        </div>
        <div class="form_item">
          <div class="form_title">证书编号：</div>
          <div class="form_content input_noborder"><input v-model="certificate_no" class="ipt_w" type="text" clearable placeholder="请输入证书编号"></div>
        </div>
        <div class="form_item">
          <div class="form_title">身份证号：</div>
          <div class="form_content input_noborder"><input v-model="id_card_no" class="ipt_w" type="text" clearable placeholder="请输入身份证号"></div>
        </div>
        <div class="tip_box">
          <p class="tip1">任意输入两项组合内容即可查询。</p>
          <p class="tip1">例如：姓名+证书编号、姓名+身份证号、证书编号+身份证号</p>
        </div>
        <!-- 查询按钮 -->
        <button class="search_btn" @click="myserch()">证书查询</button>
      </div>
      <!-- 证书列表 -->
    <div v-if="certificateList.length>1" class="searchRes">
      <p class="searchTitle">
        <span>个人证书（{{ certificateList.length }}个）</span>
        <span>操作</span>
      </p>
      <p v-for="(item,index) in certificateList" :key="index" class="p_item">
        <span class="left_name">{{ item.certificate_name }}</span>
        <span class="check" @click.stop="check(item)">查看</span>
      </p>
    </div>

      <!-- 底部提示语 -->
      <div class="tip_box1">
        <p class="tip1">查询提示：</p>
        <p class="tip1">1.证书查询条件：姓名，身份证，证书编号。</p>
        <p class="tip1">2.学员任选两项组合内容进行查询。</p>
        <p class="tip1">3.学员以姓名+身份证查询时，只能查询最近考取的证书。如存在一人多证情况，请使用姓名＋证书编号进行查询。</p>
      </div>

    <van-dialog v-model="isZsbh" title="提示" :message="msg" confirm-button-text="我知道了"></van-dialog>

  </div>
</template>

<script>
import heads from '@/components/common/heads.vue'
import { searchCertificationNew } from '@/api/credential.js'
export default {
  components: {
    heads
  },
  data() {
    return {
      isshow: false,
      title_msg: '证书查询',
      real_name: '',
      certificate_no: '',
      id_card_no: '',
      isZsbh: false,
      showMore: true,
      msg: '请输入有效的身份证号或证书编号',
      certificateList: []
    }
  },
  methods: {
    myserch() {
      var length0 = 0
      if (!this.real_name) {
        length0++
      }
      if (!this.certificate_no) {
        length0++
      }
      if (!this.id_card_no) {
        length0++
      }
      if (length0 > 1) {
        return this.$toast('请输入姓名、证书编号、身份证号其中两项内容进行查询~')
      }
      var params = {
        real_name: this.real_name,
        certificate_no: this.certificate_no,
        id_card_no: this.id_card_no,
        source: this.source
      }
      searchCertificationNew(params).then(res => {
        if (res.errNo === 0) {
          this.isZsbh = false
          const result = res.result || []
          if (result.length == 1) {
            this.$nextTick(() => {
              this.check(result[0])
            })
          } else if (result.length > 1) {
            this.certificateList = result
          } else {
            this.isZsbh = true
            this.msg = '未查询到相关证书'
          }
        } else {
          this.isZsbh = true
          this.msg = res.msg ? res.msg : '未查询到相关证书'
        }
      })
    },
    // 查看
    check(val) {
      window.location.href = val.url
      // console.log(val)
      // this.$router.push({
      //   path: '/CertificateQueryLook',
      //   query: {
      //     id: val.id
      //   }
      // })
    },
    clicks() {
      if (this.isshow === false) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.errmsg {
  color: #ee2e2e;
  padding: 15px 0 0 35px;
}
.btn {
  width: 100%;
  margin: 30px 0 0 0;
  button {
    background: #ee2e2e;
    color: #fff;
    height: 90px;
    line-height: 90px;
    width: 92%;
    display: block;
    margin: 0 auto;
    font-size: 32px;
  }
}
.img_h {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 30px;
  top: 58px;
  z-index: 1;
}
.ipt {
  width: 100%;
  margin: 50px 0 0 0;
  input {
    margin: 0 auto;
    display: block;
    width: 85%;
    height: 80px;
    border: 1px solid #d8d8d8;
    letter-spacing: 2px;
    padding: 0 0 0 50px;
    font-size: 26px;
  }
}
/deep/.van-dialog {
  border-radius: 6px;
}
p {
  margin: 0;
  padding: 0;
}
.searchRes{
  margin: 40px 40px;
  width: calc(100% - 80px);

  .searchTitle{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 20px;
  }
  .p_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    margin-bottom: 30px;
    padding-bottom: 35px;
    border-bottom: 1px solid #f5f5f5;
    .left_name {
      width: calc(100% - 80px);
    }
    .check{
      width:70px;
      display: inline-block;
      text-align: right;
      color:#ee2e2e;
      cursor:pointer;
    }
  }
}


.form_box {
  margin: 40px auto 0;
  padding: 0 60px;
  .form_item {
    display: flex;
    align-items: center;
    line-height: 60px;
    margin-bottom: 40px;
    padding: 16px 10px;
    box-sizing: border-box;
    border: 2px solid #ddd;
    border-radius: 50px;
    .form_title {
      color: #333;
      width: 180px;
      text-align: right;
      font-size: 28px;
      margin-right: 0px;
    }
    .form_content {
      flex: 1;
      .ipt_w {
        width: 100%;
      }

    }
    .input_noborder {
      /deep/.el-input__inner {
        border:none;
      }
    }
  }
  .tip_box {
    padding-left: 0px;
    text-align: left;
    .tip1 {
      font-size: 24px;
      color: #ee2e2e;
      margin: 0 0;
    }
  }

  .search_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 0;
    border: none;
    width: 220px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #ffffff;
    font-size: 26px;
    background: #ee2e2e;
  }
}
.tip_box1 {
  margin: 40px 40px 0;
  border-top: 1px solid #ddd;
  margin-top: 40px;
  text-align: left;
  padding: 30px 20px;
  .tip1 {
    color: #999;
    font-size: 24px;
    margin: 0 0;
  }
}
</style>
